import { useEffect } from "react";

const useGridHeight = () => {
  const calculateGridHeight = () => {
    const topNav = document.getElementById("topnavmenu") as HTMLElement | null;
    const footer = document.getElementById("footer") as HTMLElement | null;
    const mainHeading = document.getElementById(
      "mainheading"
    ) as HTMLElement | null;
    const submitButton = document.getElementById(
      "loadmore-button"
    ) as HTMLElement | null;

    const pageSizeSelector = document.getElementById(
      "page-size-selector"
    ) as HTMLElement | null;

    const gridFilters = document.getElementById(
      "grid-filter"
    ) as HTMLElement | null;

    const topNavHeight = topNav?.offsetHeight || 75;
    const footerHeight = footer?.offsetHeight || 40;
    const mainHeadingHeight = mainHeading?.offsetHeight || 100;

    const pageSizeSelectorHeight = pageSizeSelector?.offsetHeight || 100;

    const gridFiltersHeight = gridFilters?.offsetHeight || 100;

    const submitButtonVisible =
      submitButton && getComputedStyle(submitButton).display !== "none";
    const submitButtonHeight = submitButtonVisible
      ? submitButton.offsetHeight || 80
      : 0;

    // grid-filter

    const gridheightSum =
      topNavHeight +
      footerHeight +
      mainHeadingHeight +
      submitButtonHeight +
      pageSizeSelectorHeight +
      gridFiltersHeight +
      100;

    const gridHeight = `calc(100vh - ${gridheightSum}px)`;
    document.documentElement.style.setProperty("--grid-height", gridHeight);
  };

  calculateGridHeight();

  useEffect(() => {
    calculateGridHeight();

    const observer = new MutationObserver(() => {
      calculateGridHeight();
    });

    const submitButton = document.getElementById("loadmore-button");
    if (submitButton) {
      observer.observe(submitButton, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }
    window.addEventListener("resize", calculateGridHeight);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", calculateGridHeight);
    };
    // eslint-disable-next-line
  }, [document.getElementById("topnavmenu")?.offsetHeight]);
};

export default useGridHeight;
